// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ISaveUserRoleRequestModel {
    static getAttributeTypeMap() {
        return ISaveUserRoleRequestModel.attributeTypeMap;
    }
}
ISaveUserRoleRequestModel.discriminator = undefined;
ISaveUserRoleRequestModel.attributeTypeMap = [
    {
        "name": "userName",
        "baseName": "userName",
        "type": "string"
    },
    {
        "name": "role",
        "baseName": "role",
        "type": "string"
    }
];
//# sourceMappingURL=iSaveUserRoleRequestModel.js.map